import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVerticalAlignmentLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconVerticalAlignmentLeft"><Path fillRule="evenodd" clipRule="evenodd" d="M5 3V21H3V3H5Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M7 6H21V11H7V6Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M7 13H17V18H7V13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVerticalAlignmentLeft;
